<template>
  <div class="booking-sidebar">
    <h3 class="mb-4 sidebar-header secondary--text">Summary</h3>
    <v-skeleton-loader
      v-if="!$warehouseAddress"
      class="luna-skeleton-loader application-bg"
      type="list-item-three-line">
    </v-skeleton-loader>
    <v-img
      width="50"
      height="50"
      class="circle mb-2"
      :src="$customLogoPath"
      v-if="$customLogoPath"></v-img>
    <p class="font-size-small" v-if="$warehouseAddress">
      <strong>{{ `${$orgWarehouseName}` }}</strong
      ><br />
      {{ $warehouseAddress }}<br />
      <a
        class="font-weight-regular"
        :href="`https://maps.google.com/?q=${$warehouseAddress}`"
        target="_blank"
        rel="noopener"
        >Google Maps</a
      >
    </p>
    <template v-else></template>
    <p v-if="selectedLoadType.id" class="font-size-small selected-load-type">
      <strong
        >{{ selectedLoadType.name }} - {{ selectedLoadType.direction }}
        <template v-if="!$warehouse.settings.isLoadTypeDurationCarrierViewHidden"
          >({{ selectedLoadType.duration_min }} minutes)</template
        >
      </strong>
    </p>
    <p v-if="selectedDock.id" class="font-size-small selected-dock">
      <strong>{{ selectedDock.name }} </strong>
    </p>
    <p v-if="selectedSlot.start" class="font-size-small">
      <strong
        >{{ novaCore.getFormattedTime(selectedSlot.start, 'dddd, MMM Do, YYYY @ hh:mm a') }} ({{
          $warehouse.timezone
        }})</strong
      >
    </p>
  </div>
</template>

<script>
export default {
  computed: {
    selectedLoadType() {
      return this.$bookingData.selectedLoadType;
    },
    selectedDock() {
      return this.$bookingData.selectedDock;
    },
    selectedSlot() {
      return this.$bookingData.selectedSlot;
    }
  }
};
</script>
